import { injector } from '@asd-stan/injector/injector';

import { MeetingRepo } from '../api/meeting.repo';
import { MeetingService } from '../domain/meeting.service';

import { MEETING_REPO, MEETING_SERVICE } from './constants';

injector.set(MEETING_REPO, new MeetingRepo());
injector.set(MEETING_SERVICE, new MeetingService());
